


































































































































































import { Component, Vue, Ref, Watch } from 'vue-property-decorator'
import Chart from '@/components/Chart/index.vue'
import { classroomList } from '@/api/teachingProtection/teachManage'
import {
  outCampusStatic,
  outCampusExport
} from '@/api/teachingProtection/childCare'

@Component({
  name: 'static',
  components: {
    Chart
  }
})
export default class extends Vue {
  private staticTime: (string | number)[] = [Date.now(), Date.now()]; // 统计时间
  private recordTime: (string | number)[] = [Date.now(), Date.now()]; // 记录时间
  private staticForm: any = {
    fromTime: Date.now(),
    toTime: Date.now(),
    classroomIds: []
  };
  private recordForm: any = {
    fromTime: Date.now(),
    toTime: Date.now(),
    classroomId: '',
    recordStatus: '',
    studentName: ''
  };
  private dialogForm: any = {
    studentId: '',
    recordTime: ''
  };
  private classList: any = []; // 班级
  private series: any = [
    {
      name: '已检查-合格',
      type: 'bar',
      stack: '记录',
      data: []
    },
    {
      name: '已检查-不合格',
      type: 'bar',
      stack: '记录',
      data: []
    },
    {
      name: '未检查',
      type: 'bar',
      stack: '记录',
      data: []
    }
  ];
  private options: any = {
    color: ['#7CB8F8', '#FF8A8A', '#FFD805', '#46AE84', '#BD8DEF', '#70B603'],
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        // 坐标轴指示器，坐标轴触发有效
        type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
      }
    },
    legend: {
      data: ['已检查-合格', '已检查-不合格', '未检查']
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      containLabel: true
    },
    xAxis: [
      {
        type: 'category',
        name: '班级',
        data: [],
        axisLabel: {
          interval: 0,
          rotate: 40
        }
      }
    ],
    yAxis: [
      {
        type: 'value',
        name: '单位：人'
      }
    ],
    series: []
  };

  /* 弹框 */
  private dialogVisible: boolean = false;
  private dialogTitle: string = '';
  private infoVisible: boolean = false;
  private infoTitle: string = '记录详情';
  private recordInfo: any = {}; // 记录详情
  private curRowData: any = {}; // 当前学生信息

  @Watch('staticTime', {
    immediate: true,
    deep: true
  })
  onChangeValue(newVal: string[], oldValue: string[]) {
    this.staticForm.fromTime = newVal.length ? newVal[0] : ''
    this.staticForm.toTime = newVal.length ? newVal[1] : ''
  }
  @Watch('recordTime', {
    immediate: true,
    deep: true
  })
  onrecordTimeChangeValue(newVal: string[], oldValue: string[]) {
    this.recordForm.fromTime = newVal.length ? newVal[0] : ''
    this.recordForm.toTime = newVal.length ? newVal[1] : ''
  }

  created() {
    this.getStatic()
    this.getClassList()
  }
  /**
   * 获取班级
   */
  private async getClassList() {
    const resp = await classroomList({
      page: 1,
      size: 9999
    })
    this.classList = (resp as any).data.array || []
  }
  /**
   * 查看弹框列表
   */
  private async viewRecord(row: any) {
    this.curRowData = row
    this.dialogTitle = '生活记录'
    this.dialogForm = {
      studentId: row.studentId,
      recordTime: row.recordTime
    }
    this.dialogVisible = true
  }
  // /**
  //  * 查看弹框列表
  //  */
  // private async viewInfo(row: any) {
  //   this.infoVisible = true
  //   let Info = await lifeRecordInfo({ lifeRecordId: row.lifeRecordId })
  //   this.recordInfo = Info.data
  // }
  /**
   * 导出详细数据
   */
  private async exportRecord() {
    let promise = null
    const resp = await outCampusExport({
      ...this.recordForm
    })
    window.location = (resp as any).message
    return promise
  }

  /**
   * 柱状图
   */
  private getStatic() {
    outCampusStatic({
      ...this.staticForm
    })
      .then(res => {
        let arr = res.data.array || []
        if (arr.length === 0) {
          this.options.xAxis[0].data = []
          this.options.series = [];
          (this.$refs.staticChart as any).setOption(this.options)
          return
        }
        let xAxis: any = []
        this.series.map((item:any) => { item.data = [] })
        let series = [...this.series]
        arr.map((item: any, index: any) => {
          xAxis.push(item.classroomName)
          series[0].data.push(item.leaveCheck.standardCheck)
          series[1].data.push(item.leaveCheck.notStandardCheck)
          series[2].data.push(item.leaveCheck.notCheck)
        })
        this.options.xAxis[0].data = xAxis
        this.options.series = [...series];
        (this.$refs.staticChart as any).setOption(this.options)
      })
      .catch(() => {})
  }
  /**
   * 统计查询
   */
  private staticSearch() {
    this.getStatic()
  }
  private staticReset() {
    this.staticForm.classroomIds = []
    this.getStatic()
  }
  /**
   * 记录
   */
  private recordSearch() {
    (this.$refs.table as any).search()
  }
  private recordReset() {
    Object.keys(this.recordForm).forEach(key => {
      this.recordForm[key] = ''
    })
    this.recordForm.fromTime = this.recordTime[0]
    this.recordForm.toTime = this.recordTime[1]
    this.$nextTick(() => {
      (this.$refs.table as any).search()
    })
  }
  /**
   * 记录时间筛选
   */
  private getRecord() {
    this.recordSearch()
  }
}
